import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MonthlyReportPage from "./components/pages/MonthlyReportPage";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MonthlyReportPage />} />
                <Route path="/monthly_report" element={<MonthlyReportPage />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;